export default __webpack_public_path__ + "static/media/linkurl.5a9ab246.svg";